import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Container from 'components/Container';
import Main from 'layouts/Main';
import React from 'react';
import {
  About,
  Advantages,
  Contact,
  Description,
  Hero,
  Partners,
  PromoNumbers,
  VideoSection,
  EventSection,
} from './components';

const SeminarEvent = () => {
  return (
    <Main colorInvert={true}>
      <Hero />
      <Box bgcolor={'primary.main'}>
        <Container>
          <Description />
        </Container>
      </Box>
      <Container>
        <PromoNumbers />
      </Container>
      <Divider />
      <Container>
        <Advantages />
      </Container>
      <Box bgcolor={'alternate.main'}>
        <Container>
          <VideoSection />
        </Container>
      </Box>
      {/* <Container>
        <Speakers />
      </Container> */}

      <Container>
        <EventSection />
      </Container>
      <Divider />
      <Container>
        <About />
      </Container>
      <Box bgcolor={'primary.main'}>
        <Container paddingX={'0 !important'} maxWidth={1}>
          <Partners />
        </Container>
      </Box>
      <Container>
        <Contact />
      </Container>
    </Main>
  );
};

export default SeminarEvent;
